// Registro de push: al autenticarse, pide permiso, obtiene el token del
// dispositivo y lo guarda en el backend. Best-effort. Ver CLAUDE.md §8.
// App nativa (Capacitor) → plugin PushNotifications; navegador → FCM web.
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { initPush } from '@/firebase'
import { initNativePush } from '@/nativePush'
import { useAuth } from '@/hooks/useAuth'
import { api } from '@/services/api'

export function usePushRegistration(): void {
  const { isAuthenticated, user } = useAuth()
  const navigate = useNavigate()
  const done = useRef(false)

  useEffect(() => {
    if (done.current || !isAuthenticated || !user) return
    done.current = true

    const saveToken = async (token: string) => {
      try {
        await api.post('/notifications/token', { fcm_token: token })
      } catch {
        done.current = false // reintenta el próximo arranque
      }
    }

    if (Capacitor.isNativePlatform()) {
      initNativePush(saveToken, (url) => navigate(url))
    } else {
      initPush(saveToken)
    }
  }, [isAuthenticated, user, navigate])
}
